import React, { useState } from 'react';
import './earning.css';
import useNavigation from '../../../../shared/utils/useNavigation';
import GenerateReportModal from '../../../Modals/EarningsPayout/GenerateReportModal';


const ExportDataCard = ({
  user
}) => {
  const navigate = useNavigation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCardClick = () => {
    setIsModalOpen(true);
  };

  const handleToggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleGenerate = async (year) => {
    navigate.toEarningsReport(year);
  };

  return (
    <>
      <div 
        className='g_card g_card_hover text-center' 
        onClick={handleCardClick}
        style={{ cursor: 'pointer' }}
      >
        <span className='cm_export_btn'>
          <i className='fa-solid fa-download'></i>
        </span>
        <p className='export_title'><b>Export Data</b></p>
        <p>Download your earning reports</p>
      </div>

      <GenerateReportModal
        isOpen={isModalOpen}
        toggle={handleToggleModal}
        onGenerate={handleGenerate}
        user={user}
      />
    </>
  );
};

export default ExportDataCard;

